export default __webpack_public_path__ + "static/media/6.838cf668.jpg";